import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {NavbarService} from '../shared/services/navbar.service';
import {UserService} from '../shared/services/user.service';
import {Utils} from '../shared/utils/utils';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalConstants} from 'src/app/iwgcommon/global-constants';
import {ListComponent} from '../iwgcommon/list/list.component';
import {VendorInvoiceService} from '../shared/services/vendor-invoice.service';
import { VendorInvoiceDialogService } from '../shared/services/vendor-invoice-dialog.service';
import { CsvDataService } from 'src/app/shared/services/csv-export.service';
import { IWGSharedService } from '../shared/services/shared.service';
@Component({
  selector: 'app-vendor-invoices',
  templateUrl: './vendor-invoices.component.html',
  styleUrls: ['./vendor-invoices.component.scss']
})
export class VendorInvoicesComponent extends ListComponent implements OnInit, AfterViewInit {
  activeiconcolor = 'invoices';
  Invoice: string;
  state: any = {};
  selectedInvoice: any;
  loading = false;
  globalScopes: any;
  tabContent: any;
  name: string;
  position: number;
  weight: number;
  symbol: string;
  lastColIndex = 10; // total number of cols - 1, index starts from 0

  showManager = false;
  showClient = false;
  showContractor = false;
  ShowCreateInvoice = false;
  allowEdit = false;
  exportColDetails: any;
  fileName = '';
    showFooter = true;
    embedStatus = "notembed";  

  constructor(private router: Router, utils: Utils, vendorInvoiceService: VendorInvoiceService,
              userService: UserService, renderer: Renderer2, private changeDetectorRef: ChangeDetectorRef,
              public nav: NavbarService, zone: NgZone, private route: ActivatedRoute, 
              private vendorInvoiceDialogService: VendorInvoiceDialogService,private csvDataService: CsvDataService,  public sharedService: IWGSharedService) {
    super(vendorInvoiceService,  utils, renderer, userService, zone,  sharedService);
    this.globalScopes = GlobalConstants.globalScopes;
    this.router.routeReuseStrategy.shouldReuseRoute = (): boolean => {
      return false;
    };
  }

  ngOnInit(): void {

      var isEmbed = this.sharedService.getIsEmbed();
      if (isEmbed === true) {
          this.nav.show(isEmbed);
          this.embedStatus = "embed";
          history.pushState(null, null, null);
          window.addEventListener('popstate', () => {
              history.pushState(null, null, null);
          });
          this.showFooter = false;
      }
      else {
          this.nav.show();
          this.nav.setActiveMenu('invoices');
          this.nav.setActiveModuleMenu({ 'isVisible': true, 'activeMenu': 'invoices' });
          this.showFooter = true;
      }

   
    this.selectedInvoice = 0;
    this.state.global_scope = 1;
    this.listColumns = ['IDCol', 'InvoiceNumber', 'Title', 'Invoice', 'InvoiceDate', 
        'Candidate', 'Client', 'Manager', 'TotalInEngagement', 'Status', 'OprMenu'];

    const role = this.userService.getRole();
    if (role == 'Worker')
    {            
        if(!this.userService.getAORDisabled()) {
          this.ShowCreateInvoice = true;
        }                             
        
        this.showManager = true;
        this.showClient = true;
        this.allowEdit = true;

    } else if (role == 'Client Manager') {                                                     
        this.showContractor = true;            
    } else if (role == 'Client Program Manager' || role == 'Admin') {                                                     
        this.showContractor = true;
        this.showManager = true;            
    }

    this.state = {limit: 25, page: 1, global_scope: 1, country: -1, state: -1}; // setting default values

    this.route.queryParams.subscribe(params => {      
        if (params) {
          this.state = Object.assign({}, this.state, (params));

          if (params.start) {
            this.state.start = new Date(params.start);
          }
          if (params.end) {
            this.state.end = new Date(params.end);
          }
          // this.state.country = parseInt('' + this.state.country);
        }
      });

    super.ngOnInit();
    this.generateListColumns();
    this.setStateParams();
    this.getItems();
    this.exportColDetails = {
      'IDCol': {'heading': '"ID"', 'dataFieldName': 'DisplayID'}, 
      'InvoiceNumber': {'heading': 'Invoice Number', 'dataFieldName': 'InvoiceNumber'}, 
      'Title': {'heading': 'Invoice Title', 'dataFieldName': 'Title'}, 
      'Invoice': {'heading': 'Invoice', 'dataFieldName': 'ID'},  
      'InvoiceDate': {'heading': 'Invoice Date', 'dataFieldName': 'InvoiceDate'},               
      'Candidate': {'heading': 'Contractor', 'dataFieldName': 'Candidate'}, 
      'Client': {'heading': 'Client', 'dataFieldName': 'Client'}, 
      'Manager': {'heading': 'Manager', 'dataFieldName': 'Manager'}, 
      'Amount': {'heading': 'Amount', 'dataFieldName': 'TotalInEngagmentCurrency', 'dataFormat': 'currency', 'currencyCodeField': 'EngamentCurrencyCode'},
      'Status': {'heading': 'Status', 'dataFieldName': 'Status'}
    }
    this.fileName = 'invoices.csv';
    }

    showVendorInvoiceDialog = (ev, existingVendorInvoiceId) => {
        this.displayVendorInvoiceDialog(ev, existingVendorInvoiceId);
    }

    displayVendorInvoiceDialog = (ev, existingVendorInvoiceId) => {
        this.vendorInvoiceDialogService.show(ev, existingVendorInvoiceId);
    }

  ngAfterViewInit(): void {
    // this._cd.detach();
    super.ngAfterViewInit();
  }

  generateListColumns(): void {
    this.displayedColumns = [...this.listColumns];

    if (!this.showClient) {
      this.removeColFromDisplay('Client');
    }

    if (!this.showContractor) {
      this.removeColFromDisplay('Candidate');
    }

    if (!this.showManager) {
      this.removeColFromDisplay('Manager');
    }

  }

  editInvoice = (ev, vendorInvoiceId) => {
    this.vendorInvoiceDialogService.show(ev, vendorInvoiceId);
  }
  exportTable () {
    let exportColList = [];
    exportColList.push('InvoiceNumber','Title', 'InvoiceDate', 'Candidate', 
        'Client', 'Manager', 'Amount', 'Status');    
    this.csvDataService.exportToCsv(this.fileName, this.items, this.exportColDetails, exportColList);
  }
}
